import UniversalActivityHistory from "./universalActivityHistory";
export default UniversalActivityHistory;